const INITIAL_STATE = {
  hub: null,
};

export const hubConnectionSuccess = "HUB_CONNECTION_SUCCESS";

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case hubConnectionSuccess:
      return { ...state, hub: action.payload };
    default:
      return state;
  }
};
